// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import Vuex from 'vuex';
import 'vuetify/dist/vuetify.min.css';
import Vuetify from 'vuetify';
import Cookie from 'vue-cookie';
import Lang from 'vuejs-localization';
import Resource from 'vue-resource';
import 'bootstrap-icons/font/bootstrap-icons.css';

import App from './App';
import router from './router';
import store from './store';
import WebHelper from './helpers/web';
import Storage from './helpers/storage';
import TimeHelper from './helpers/time';

import Categories from './components/webshop/Categories';
import Items from './components/webshop/Items';
import MenuCategories from './components/webshop/MenuCategories';
import MenuItems from './components/webshop/MenuItems';

import('../node_modules/vuetify/dist/vuetify.min.css');

Vue.use(Vuetify, {
  theme: {
    primary: '#efa546',
    secondary: '#efa546',
    accent: '#efa546',
    error: '#d84315',
    info: '#2196F3',
    success: '#4CAF50',
    warning: '#FF8F00',
  },
});

Vue.config.productionTip = false;

Vue.use(Resource);
Vue.http.options.root = process.env.NODE_ENV === 'production' ? '/webshopplanet' : '/api';
Vue.http.options.xhr = { withCredentials: true };
Vue.http.options.credentials = true;

Vue.use(Vuex);

Vue.use(Cookie);

// Vue localization
Lang.requireAll(require.context('./lang', true, /\.js$/));
Vue.use(Lang);

Vue.use(WebHelper);
Vue.use(TimeHelper);
Vue.use(Storage);

Vue.component('Categories', Categories);
Vue.component('Items', Items);
Vue.component('MenuCategories', MenuCategories);
Vue.component('MenuItems', MenuItems);

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store: store(),
  template: '<App/>',
  components: { App },
});



// WEBPACK FOOTER //
// ./src/main.js